module.exports = __webpack_public_path__ + "img/3hr-03.4be33e9b.jpg";